import React from 'react';
import { useForm } from 'react-hook-form';

export const FallbackFormContext = React.createContext(null);
export const useFallbackFormContext = () => React.useContext(FallbackFormContext);
export const FallbackFormProvider = ({ children }) => {
    const fallbackForm = useForm();

    return (
        <FallbackFormContext.Provider value={fallbackForm}>
            {children}
        </FallbackFormContext.Provider>
    );
};
